// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__pm0KK","infoContainer":"Footer_infoContainer__-X+JN"};